import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';
import { useMeContext } from '~/modules/me';

export const CHANGE_RESOURCE_USER_TASK_ASSIGNMENT_SUMMARY = gql`
  query getChangeResourceUserTaskAssignmentSummary(
    $projectId: String!
    $existingResourceUserId: String!
    $newResourceUserId: String!
    $asOfDate: Date2
    $filter: GetResourceUsersFilter!
  ) {
    resourceUsers2(filter: $filter) {
      id
      changeResourceUserTaskAssignmentSummary(
        projectId: $projectId
        existingResourceUserId: $existingResourceUserId
        newResourceUserId: $newResourceUserId
        asOfDate: $asOfDate
      ) {
        hasTaskAssignmentConflict
      }
    }
  }
`;

export const CHANGE_RESOURCE_USER_TASK_ASSIGNMENT_SUMMARY_V2 = gql`
  query getChangeResourceUserTaskAssignmentSummaryV2(
    $projectId: String!
    $existingResourceUserId: String!
    $newResourceUserId: String!
    $asOfDate: Date2
  ) {
    changeResourceUserTaskAssignmentSummary(
      projectId: $projectId
      existingResourceUserId: $existingResourceUserId
      newResourceUserId: $newResourceUserId
      asOfDate: $asOfDate
    ) {
      hasTaskAssignmentConflict
    }
  }
`;

const useLegacyChangeResourceUserTaskAssignmentSummary = ({
  asOfDate,
  existingResourceUserId,
  newResourceUserId,
  projectId,
  skip
}) => {
  const { data, loading } = useQuery(
    CHANGE_RESOURCE_USER_TASK_ASSIGNMENT_SUMMARY,
    {
      variables: {
        asOfDate,
        projectId,
        existingResourceUserId,
        newResourceUserId,
        filter: { userIds: [existingResourceUserId] }
      },
      fetchPolicy: 'cache-and-network',
      skip
    }
  );

  return {
    hasTaskAssignmentConflict:
      data?.resourceUsers2?.[0]?.changeResourceUserTaskAssignmentSummary
        .hasTaskAssignmentConflict,
    isLoading: loading
  };
};

const useChangeResourceUserTaskAssignmentSummaryV2 = ({
  asOfDate,
  existingResourceUserId,
  newResourceUserId,
  projectId,
  skip
}) => {
  const { data, loading } = useQuery(
    CHANGE_RESOURCE_USER_TASK_ASSIGNMENT_SUMMARY_V2,
    {
      variables: {
        asOfDate,
        existingResourceUserId,
        newResourceUserId,
        projectId
      },
      fetchPolicy: 'cache-and-network',
      skip
    }
  );

  return {
    hasTaskAssignmentConflict:
      data?.changeResourceUserTaskAssignmentSummary?.hasTaskAssignmentConflict,
    isLoading: loading
  };
};

const useChangeResourceUserTaskAssignmentSummary = ({
  asOfDate,
  existingResourceUserId,
  newResourceUserId,
  projectId,
  skip
}) => {
  const {
    featureFlags: { isPsaRmpEnhancedProjectManagerPersonaEnabled }
  } = useMeContext();

  const legacyChangeResourceUserTaskAssignmentSummaryResult = useLegacyChangeResourceUserTaskAssignmentSummary(
    {
      asOfDate,
      existingResourceUserId,
      newResourceUserId,
      projectId,
      skip: skip || isPsaRmpEnhancedProjectManagerPersonaEnabled
    }
  );

  const changeResourceUserTaskAssignmentSummaryResult = useChangeResourceUserTaskAssignmentSummaryV2(
    {
      asOfDate,
      existingResourceUserId,
      newResourceUserId,
      projectId,
      skip: skip || !isPsaRmpEnhancedProjectManagerPersonaEnabled
    }
  );

  return isPsaRmpEnhancedProjectManagerPersonaEnabled
    ? changeResourceUserTaskAssignmentSummaryResult
    : legacyChangeResourceUserTaskAssignmentSummaryResult;
};

export default useChangeResourceUserTaskAssignmentSummary;
